import { useContext, useEffect, useState } from 'react';
import { getContentWithChildren } from '../api/contentDeliveryApi';
import { AppContext } from '../context/AppContext';

export const useFetch = <T>(contentId: string) => {
	const appContext = useContext(AppContext);
	const [data, setData] = useState<T | null>(null);

	useEffect(() => {
		const fetchData = async () => {
			const response = await getContentWithChildren({
				contentId: contentId,
				lang: appContext?.language,
			});
			setData(response);
		};
		fetchData();
	}, [contentId]);

	return { data };
};
